import { useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CardServico from 'shared/component/CardServico';
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import React, { useState } from 'react';
import { getServiceName, getTkItem, launch } from 'shared/helper/serviceLauncher';
import { TK_TIPOS_ACAO_SELECAO_SERVICO, trackServiceSelectORA } from 'shared/helper/tracker';

const useStyles = makeStyles(theme => ({
  ripple: {
    width: '100%',
    height: '100%',
    padding: '4px 16px 16px 16px',
    borderRadius: '4px',
    [theme.breakpoints.up('md')]: {
      padding: '12px',
      backgroundColor: theme.palette.background.colorContrast,
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
    },
    '&:focus': {
      outline: `3px solid ${theme.palette.primary.main}`,
      outlineOffset: '2px',
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  },
  value: {
    fontSize: '1.2em',
    lineHeight: '1.1em',
    color: '#333',
    fontWeight: 'bold',
    position: 'relative',
    top: '10px',
    margin: '0',
    paddingBottom: '0',
    marginBottom: '26px'
  },
  iconDrawerFocus: {
    '&:focus': {
      boxShadow: '0 0 0 2px #c2850c',
      border: '1px solid #c2850c',
      outline: 'none'
    },
  }
}));

export default function IconDrawer(props) {

  const classes = useStyles();
  const matches = useMediaQuery(theme => theme.breakpoints.up('md'));
  const isNotMobile = useMediaQuery(theme => theme.breakpoints.up(334));

  const [exibeMaisServicos, setExibeMaisServicos] = useState(false);

  const servicos = (props.items || [])
                  .filter(s => s.isAtivo == true || s.ativo == true)
                  .map(servico => {
                    return {
                      ...servico,
                      callback: () => {
                        launch(getTkItem(servico, TK_TIPOS_ACAO_SELECAO_SERVICO.HIGHLIGHT));
                        trackServiceSelectORA(TK_TIPOS_ACAO_SELECAO_SERVICO.HIGHLIGHT, getServiceName(servico));
                      }
                    }
                  })

  const renderMaisServicos = () => {
    if (servicos && servicos?.length > 5) {
      if (exibeMaisServicos || servicos?.length === 6) {
        return (
          <CardServico
            xsOneColumn={props.xsOneColumn}
            servicos={servicos}
            maxColumns={(isNotMobile ? "" : 1)}
            grupo={{ color: "#1351B4", backgroundColor: "#D4E5FF" }}
          />
        )
      } else {
        return (
          <CardServico
            xsOneColumn={props.xsOneColumn}
            servicos={
              [...servicos.slice(0, 5), 
                {
                  tipo: 'SERVICO',
                  isAtivo: true,
                  titulo: 'Mais Serviços',
                  icone: "fas fa-ellipsis-h",
                  callback: () => setExibeMaisServicos(true),
                }
              ]
            }
            maxColumns={(isNotMobile ? "" : 1)}
            grupo={{ color: "#1351B4", backgroundColor: "#D4E5FF" }}
          />
        )
      }
    } else {
      return (
        <CardServico
          xsOneColumn={props.xsOneColumn}
          servicos={servicos}
          maxColumns={(isNotMobile ? servicos.length > 3 ? 3 : servicos.length : 1)}
          grupo={{ color: "#1351B4", backgroundColor: "#D4E5FF" }}
        />
      )
    }
  }

  return (
    <React.Fragment>
      <section className={classes.iconDrawerFocus}  >
      {props.title && 
      <Hidden xsDown={props.hideTitleXs}>
        <h2 id='menu' tabIndex={-1} className={classes.value} >
          {props.title}
        </h2>
      </Hidden>}

      <Grid container justify="flex-start" alignItems={matches ? 'stretch' : 'flex-start'}>
        { servicos && renderMaisServicos()}
      </Grid>
      </section>
    </React.Fragment>
  );
}

